import { getColorwayWithTransparency, getSectionProps } from '@/utils/styles';
import { HomepageHeroProps } from 'libs/contentful/props';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import Media from '../shared/Media/Media';
import { cn } from '@/utils/styles';
import HomepageHeroList from './shared/HomepageHeroList';
import HeroCTA from '@/components/HeroConsolidated/shared/HeroCTA';

const HomepageHeroTwoColumnVariant = ({
  sys,
  sectionName,
  headline,
  copy,
  desktopImage,
  desktopAspectRatio,
  mobileImage,
  mobileAspectRatio,
  color,
  transparentBackground,
  showEmailInput,
  emailInputButtonText,
  enrollmentUrl,
  disclaimers,
}: HomepageHeroProps) => {
  return (
    <div
      {...getSectionProps(
        undefined,
        undefined,
        sectionName,
        cn(getColorwayWithTransparency(color, transparentBackground)),
      )}
      data-testid="homepage-hero-two-column-variant">
      <div className="content-wrapper">
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="sm:basis-1/2">
            <div
              className="font-sans text-heading-md sm:text-heading-xxl md:text-heading-xxxl font-semibold mb-4"
              {...liveUpdateAttrs(sys?.id, 'headline')}>
              {headline && <RichTextHeadline headline={headline} level="h1" />}
            </div>
            <HomepageHeroList sys={sys} copy={copy} listDisplay="block" />
            <div className={'block sm:hidden'}>
              <Media
                media={desktopImage}
                mobileMedia={mobileImage}
                aspectRatio={desktopAspectRatio}
                mobileAspectRatio={mobileAspectRatio}
                sizes="(max-width: 750px) 100vw, 600px"
                priority
              />
            </div>
            <HeroCTA
              sys={sys}
              enrollmentUrl={enrollmentUrl}
              showEmailInput={showEmailInput}
              emailInputButtonText={emailInputButtonText}
              disclaimers={disclaimers}
              className={
                '[&_input]:bg-bg-primary/10 [&_input]:text-current [&_input]:placeholder:text-current [&_input]:placeholder:opacity-70 [&_input]:border-grey-200'
              }
            />
          </div>
          <div className="hidden sm:block sm:basis-1/2">
            <Media
              media={desktopImage}
              mobileMedia={mobileImage}
              aspectRatio={desktopAspectRatio}
              mobileAspectRatio={mobileAspectRatio}
              sizes="(max-width: 750px) 100vw, 600px"
              priority
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomepageHeroTwoColumnVariant;
